import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@sbercloud+uikit-product-icons@11.4.0_@sbercloud+figma-tokens-admin@17.1.0_@sbercloud+f_cb6678d753d61418a74bded868816121/node_modules/@sbercloud/uikit-product-icons/dist/esm/sprite/svg/sprite-system.symbol.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@snack-uikit+icons@0.26.2_react@18.3.1/node_modules/@snack-uikit/icons/dist/esm/sprite/svg/sprite.symbol.svg");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@snack-uikit+typography@0.8.6_react@18.3.1/node_modules/@snack-uikit/typography/dist/esm/components/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@snack-uikit+loaders@0.9.1_react@18.3.1/node_modules/@snack-uikit/loaders/dist/esm/components/Spinner/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@snack-uikit+loaders@0.9.1_react@18.3.1/node_modules/@snack-uikit/loaders/dist/esm/components/Sun/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.26.10_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.86.3/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.26.10_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.86.3/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.28_@babel+core@7.26.10_@opentelemetry+api@1.9.0_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.86.3/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_pages/Article/ArticlePage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/src/_pages/ErrorBoundary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/_pages/MainPge/MainPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardList"] */ "/app/src/components/static/CardList/CardList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CardsGrid"] */ "/app/src/components/static/CardList/utils.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Feedback"] */ "/app/src/components/static/Feedback/Feedback.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyRights"] */ "/app/src/components/static/Footer/CopyRights.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FooterNav"] */ "/app/src/components/static/Footer/FooterNav/FooterNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderHeroSection"] */ "/app/src/components/static/HeaderHeroSection/HeaderHeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HighLightCode"] */ "/app/src/components/static/HighLightCode/HighLightCode.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/static/icons/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["InitialSearch"] */ "/app/src/components/static/InitialSearch/InitialSearch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchModal"] */ "/app/src/components/static/InitialSearch/SearchModal.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/static/InitialSearchInput/SERPSearch.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/static/LinkWrapper/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/static/LoadingOverlay/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ListCollapseWrapper"] */ "/app/src/components/static/NavListItem/ListCollapseWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/static/NavListItem/style.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["OIDCLoginRedirect"] */ "/app/src/components/static/OIDCLoginRedirect/OIDCLoginRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformMultiSelect"] */ "/app/src/components/static/PlatformMultiSelect/PlatformMultiSelect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToTop"] */ "/app/src/components/static/ScrollToTop/ScrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SidebarMenu"] */ "/app/src/components/static/SidebarMenu/SidebarMenu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TableOfContent"] */ "/app/src/components/static/TableOfContent/TableOfContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicPageProviders"] */ "/app/src/context/DynamicPages.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppLayout"] */ "/app/src/layout/Layout.tsx");
